import React from 'react';
import { EmptyFeed, DashboardHeading, Breadcrumbs } from 'components';
import styles from './IntegrationFeedNoResults.module.scss';

// TO-DO IntegrationType prop is temporarily until breadcrumbs centralised
interface GroupContentProps {
  integrationType: any;
}
export const IntegrationFeedNoResults: React.FC<GroupContentProps> = ({ integrationType }) => {
  return (
    <div>
      <Breadcrumbs
        links={[
          {
            label: integrationType,
            to: '/integration/' + integrationType,
          },
        ]}
      />
      <div className={styles.Heading}>
        <DashboardHeading level={1}>Activity Feed</DashboardHeading>
      </div>
      <EmptyFeed message={'Add documents to see app activity'} />
    </div>
  );
};
